import { CompanyOperationalOverviewContent } from "../../features/companyOverview";

function CompanyOverviewScreen() {
  return <CompanyOperationalOverviewContent />;
}

export default CompanyOverviewScreen;
